<template>
  <div class="card-body">
    <div class="row">
      <div class="btn-group float-right pl-2">
        <button
          type="button"
          class="btn btn-default btn-lg"
          style="cursor: pointer"
          data-toggle="tooltip"
          data-placement="right"
          title="Traza Viaje"
        >
          <h3 style="font-size: 15px">
            <input
              type="checkbox"
              v-model="form.traza"
              @change="getTrazabilidad()"
            />
            <b>
              <i
                style="font-size: 25px"
                class="fas fa-map-marked-alt p-1 ml-1"
              ></i>
            </b>
          </h3>
        </button>
      </div>
      <div class="btn-group float-right pl-2">
        <button
          type="button"
          class="btn btn-default btn-lg"
          style="cursor: pointer"
          data-toggle="tooltip"
          data-placement="right"
          title="Traza Novedades"
        >
          <h3 style="font-size: 15px">
            <input
              type="checkbox"
              v-model="form.novedades"
              @change="getSeguimientos()"
            />
            <b>
              <i
                style="font-size: 25px"
                class="fas fa-exclamation-triangle ml-1"
              ></i>
            </b>
          </h3>
        </button>
      </div>
      <div class="float-right pl-2 mt-2 pt-1">
        <button
          type="button"
          class="btn btn-success"
          @click="generarExcelTraza()"
        >
          <i class="far fa-file-excel"></i>
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <gmap-map
        class="border border-dark"
        :center="center"
        :zoom="10"
        style="width: 100%; height: 480px"
      >
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :animation="2"
          class="border border-dark"
          @click="toggleInfoWindow(m, index, m.info)"
        ></gmap-marker>
        <gmap-marker
          :key="index"
          v-for="(m, index) in markersSeg"
          :position="m.position"
          :icon="m.icon"
          :animation="2"
          @click="toggleInfoWindow(m, index, m.info)"
        ></gmap-marker>
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div v-html="infoContent"></div>
        </gmap-info-window>
        <!-- <gmap-polygon
          :options="{ fillColor: '#FF0000' }"
          v-for="poligono in poligonos"
          :key="poligono.id"
          :paths="poligono.path"
          :editable="false"
          :draggable="false"
          @click="toggleInfoWindowPoli(poligono, poligono.id, poligono.info)"
        /> -->
        <!-- <gmap-circle
          v-for="circular in circunferencias"
          :key="circular.id"
          :center="circular.center"
          :radius="circular.radius"
          :info="circular.info"
          @click="toggleInfoWindowCir(circular, circular.id, circular.info)"
        ></gmap-circle> -->
        <gmap-polyline
          v-if="pathRuta.length"
          :options="polylineOptions"
          :path="pathRuta"
          :editable="false"
          ref="polyline"
        >
        </gmap-polyline>
      </gmap-map>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "VentanaOperacionesSeguimientoMapa",

  data() {
    return {
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      form: {
        traza: false,
        novedades: false,
      },
      polylineOptions: {
        strokeColor: "#ff1c79",
        strokeOpacity: "0.7",
        strokeWeight: 8,
      },
      center: { lat: 4.651371, lng: -74.071509 },
      markers: [],
      markersSeg: [],
      pathRuta: [],
      pathPoli: [],
      puntoInicialLat: null,
      puntoInicialLng: null,
      puntoFinalLat: null,
      puntoFinalLng: null,
      infoPuntoFinal: "",
      infoPuntoInicial: "",
      puntofin: null,
      vehiculo_id: null,
      latitud: null,
      longitud: null,
      puntosTraza: [],
      path: [],
    };
  },

  methods: {
    async getTrazabilidad() {
      this.puntosTraza = [];
      this.markers = [];
      if (this.form.traza) {
        this.puntosTraza = await this.$parent.vehiculo.traza;
        this.trazaViaje();
        //await this.getRuta();
      }
    },

    trazaViaje() {
      if (this.puntosTraza.length) {
        for (let index = 0; index < this.puntosTraza.length; index++) {
          const marker = {
            lat: parseFloat(this.puntosTraza[index].latitud),
            lng: parseFloat(this.puntosTraza[index].longitud),
          };
          this.markers.push({
            id: this.puntosTraza[index].id,
            position: marker,
            icon: "/img/icon_punt_ruta.png",
            info: this.puntosTraza[index].ventana,
          });
        }
        this.puntoInicialLat = parseFloat(this.puntosTraza[0].latitud);
        this.puntoInicialLng = parseFloat(this.puntosTraza[0].longitud);
        this.infoPuntoInicial = this.puntosTraza[0].ventana;

        this.markers.push({
          id: this.puntosTraza[0].id,
          position: {
            lat: this.puntoInicialLat,
            lng: this.puntoInicialLng,
          },
          icon: "/img/icon_punto_g_ok.png",
          info: this.infoPuntoInicial,
        });

        this.puntofin = this.puntosTraza.slice(-1);
        this.puntoFinalLat = parseFloat(this.puntofin[0].latitud);
        this.puntoFinalLng = parseFloat(this.puntofin[0].longitud);
        this.infoPuntoFinal = this.puntofin[0].ventana;

        this.markers.push({
          id: this.puntofin[0].id,
          position: {
            lat: this.puntoFinalLat,
            lng: this.puntoFinalLng,
          },
          icon: "/img/icon_punto_g.png",
          info: this.infoPuntoFinal,
        });

        const marker1 = {
          lat: this.puntoFinalLat,
          lng: this.puntoFinalLng,
        };
        this.center = marker1;
      } else {
        this.form.traza = false;
        this.$swal({
          title: "Tramas no encontradas!",
          text: "No se encontraron tramas para este viaje",
          icon: "warning",
        });
      }
    },

    async getSeguimientos() {
      this.path = [];
      this.markersAd = [];
      this.markersEm = [];
      this.$parent.$parent.cargando = true;
      let self = this;
      await axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/getSeguimientos",
          {
            params: {
              viaje_id: this.$parent.viaje.id,
              viaje_type: " App\\Viaje",
            },
          }
        )
        .then(async function(response) {
          self.markersSeg = [];
          const datosSeguimientos = response.data;
          if (self.form.novedades == true) {
            if (datosSeguimientos.length) {
              await datosSeguimientos.forEach((seguimiento) => {
                if (
                  seguimiento.latitud != null &&
                  seguimiento.longitud != null
                ) {
                  let ventana =
                    '<div class="wrapper"><h3 style="font-size:15px" class="text-center">Vehículo: ' +
                    self.$parent.viaje.vehiculo.placa +
                    "</h3><hr><b>Fecha Reporte: </b> " +
                    seguimiento.fecha_reporte +
                    "<br> <b>Viaje: </b>" +
                    seguimiento.viaje_id +
                    "<br> <b>Transportadora: </b>" +
                    (self.$parent.viaje.transportadora
                      ? self.$parent.viaje.transportadora.razon_social
                      : "Sin asignar") +
                    "<br> <b>Posicion: </b>" +
                    seguimiento.latitud +
                    ", " +
                    seguimiento.longitud +
                    "<br> <b>Dirección: </b> " +
                    seguimiento.direccion +
                    " Km/h" +
                    "<br> <b>Novedad: </b>" +
                    seguimiento.nTipoNovedad;
                  const marker = {
                    lat: parseFloat(seguimiento.latitud),
                    lng: parseFloat(seguimiento.longitud),
                  };
                  self.markersSeg.push({
                    position: marker,
                    icon: "/img/icons/map-warning-icon.png",
                    info: ventana,
                    center: {
                      marker,
                    },
                  });
                }
              });
            } else {
              self.form.novedades = false;
              self.$swal({
                title: "Seguimientos no encontrados!",
                text: "No se encontraron seguimientos para este viaje",
                icon: "warning",
              });
            }
          }
          self.$parent.$parent.cargando = false;
        })
        .catch(function(error) {
          self.$parent.$parent.cargando = false;
          self.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    /* async getRuta() {
      this.pathRuta = [];
      this.pathPoli = await this.$parent.det_ruta;
      if (this.pathPoli.length) {
        for (let i = 0; i < this.pathPoli.length; i++) {
          if (i == 0) {
            this.pathRuta.push({
              lat: parseFloat(this.pathPoli[i].lat_ini),
              lng: parseFloat(this.pathPoli[i].lon_ini),
            });
          }
          this.pathRuta.push({
            lat: parseFloat(this.pathPoli[i].lat_fin),
            lng: parseFloat(this.pathPoli[i].lon_fin),
          });
        }
      }
    }, */

    toggleInfoWindow: function(marker, idx, ventana) {
      this.infoWindowPos = marker.position;
      this.infoContent = ventana;
      this.center = marker.position;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowPoli: function(poli, idx, ventana) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowCir: function(cir, idx, ventana) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    async generarExcelTraza() {
      let viaje_id = this.$parent.viaje.id;
      this.$parent.$parent.$parent.cargando = true;
      await axios({
        method: "POST",
        url: "/api/hidrocarburos/viajes/trazaExport",
        data: { viaje_id },
      })
        .then((response) => {
          let data = response.data;
          this.$parent.$parent.$parent.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.$parent.$parent.cargando = false;
        });
    },
  },
};
</script>
